
import { Component, Mixins } from 'vue-property-decorator';
import { SearchParametersType } from '~/interfaces/log.interface';
import UserRightsMixin from '~/mixins/UserRightsMixin';
import { LogModule } from '~/store/modules/log';
import { isDeviceIdValid, isEmailValid } from '~common-services/form-validation';

@Component
export default class SearchParameters extends Mixins(UserRightsMixin) {
    valid = true;
    // mail from (maker)
    emailFrom = '';

    // mac or serial
    deviceId = '';

    methodSearch = '';

    emailRules = [
        (v: string) => v === '' || isEmailValid(v.trim()) || 'Invalid email',
    ];

    deviceIdRules = [
        (v: string) => v === '' || isDeviceIdValid(v),
    ];

    methods = LogModule.availableMethods;

    get adminMailFrom() {
        return LogModule.adminMailFrom;
    }

    get adminDeviceId() {
        return LogModule.deviceId;
    }

    get hasActiveParameters() {
        return this.adminMailFrom || this.deviceId || this.methodSearch;
    }

    validForm() {
        return this.valid &&
            (this.emailFrom !== '' || this.deviceId !== '' || this.methodSearch !== '');
    }

    async validate() {
        const params: SearchParametersType = {} as SearchParametersType;
        params.emailFrom = this.emailFrom.trim();
        params.deviceId = this.deviceId;
        params.method = this.methodSearch;
        await LogModule.setSearchLog(params);
    }

    resetForm() {
        // we don't use reset from form because we need to put string as '' and not undefined
        this.emailFrom = '';
        this.deviceId = '';
        this.methodSearch = '';
    }

}
